module.exports = __webpack_public_path__ + "img/黄倩-考试宝典.551d4528.jpg";